import { render, staticRenderFns } from "./RoomsList.vue?vue&type=template&id=f5b3bc86"
import script from "./RoomsList.vue?vue&type=script&lang=js"
export * from "./RoomsList.vue?vue&type=script&lang=js"
import style0 from "./RoomsList.vue?vue&type=style&index=0&id=f5b3bc86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports